import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { QuoteCompaisonColumnType } from '../../../types';
import { keys } from './keys';

type Command = {
  groupId: string;
  /** Updates this criterion when set, creates one at `order` otherwise. */
  columnId?: string;
  label: string;
  type: QuoteCompaisonColumnType;
  order: number;
};

async function saveQuoteColumn(command: Command) {
  const { error } = command.columnId
    ? await apiClient
      .from('quote_comparison_columns')
      .update({ label: command.label, type: command.type })
      .eq('id', command.columnId)
    : await apiClient
      .from('quote_comparison_columns')
      .insert({
        group_id: command.groupId,
        label: command.label,
        type: command.type,
        order: command.order,
        visible: true,
      });

  if (error) {
    throw error;
  }
}

export function useSaveQuoteColumn() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveQuoteColumn,
    onSuccess: (_data, command) => {
      queryClient.invalidateQueries({ queryKey: keys.columns(command.groupId) });
      enqueueSnackbar(command.columnId ? 'Critère modifié.' : 'Critère ajouté.', 'success');
    },
  });
}
